var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47.09 66.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#16629c;}.f{clip-path:url(#d);}.g{fill:none;}.h{fill:#182641;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 47.09,
    height: 66.36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M37.55,44.49l1.69,1.96s-13.02,9.07-23.31,13.23c-7.48,3.03-13.93,3.04-14.05-.16-.1-2.53,.85-3.8,1.24-4.22-4.26,3.89-4.02,9.28-.11,10.51,4.03,1.27,10.69,.57,21.9-5.07,11.21-5.64,17.48-10.83,17.48-10.83l1.58,1.91,3.12-8.65-9.54,1.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M4.31,24.27l1.01-.73v26.5h.51V23.17l1.28-.92v12.4h.51v-12.77l1.45-1.04V60.73c.17-.03,.34-.06,.51-.09V20.47l1.01-.73V60.42c1.67-.38,3.48-.95,5.35-1.71,2.37-.96,4.88-2.17,7.35-3.48V23.19l-6.31-2.15h-.06l-6.33-2.18-1.01,.72-.51,.37-1.45,1.04-.51,.37-1.28,.92-.51,.37-1.86,1.33V60.49c.17,.1,.34,.19,.53,.28,.11,.03,.21,.05,.33,.07V24.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M35.85,9.61l-7.92-4.91v-1.85l13.09,6.02L28.02,0l-7.32,3.8v5.07l7.23-2.75,7.92,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M35.85,16.64l-7.92-4.91v-1.85l13.09,6.02L28.02,7.03l-7.32,3.8v5.07l7.23-2.75,7.92,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M41.02,22.92l-13-8.87-7.32,3.8v2.88l3.04,1.04,4.19-1.59,7.92,3.49-7.92-4.91v-1.85l13.09,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M41.02,29.95l-13-8.87-3.21,1.67v5.64l3.13-1.19,7.92,3.49-7.92-4.91v-1.85l13.09,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M41.02,36.97l-13-8.87-3.21,1.67v5.64l3.13-1.19,7.92,3.49-7.92-4.91v-1.85l13.09,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M28.02,35.13l-3.21,1.67v5.64l3.13-1.19,7.92,3.49-7.92-4.91v-1.85l11.18,5.14,.52-.07-11.61-7.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M27.93,46.85v-1.85l7.17,3.28c.34-.22,.66-.43,.97-.63-2.69-1.83-5.37-3.67-8.06-5.5l-3.21,1.67v5.64l3.13-1.19,4.23,1.86c.18-.11,.36-.22,.54-.33l-4.76-2.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M27.93,51.92c.24,.11,.48,.22,.71,.33,.74-.43,1.45-.86,2.15-1.28l-2.78-1.9-3.22,1.67v3.69c1.06-.58,2.11-1.17,3.13-1.76v-.75h0Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.336e1333b59b0a04649bb59df7270357.svg";
export { ForwardRef as ReactComponent };